import Api from '.';
import { DEVURL } from './envUrl';
const headers = {
  'Access-Control-Allow-Headers': 'Content-Type',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
};

// Adapter function to transform new API structure to legacy structure
// Handles new format with pyName and Rank properties
const transformRoleOwnerData = (responseData) => {
  if (!responseData || !Array.isArray(responseData.ArtworkAgilityProjects)) {
    return responseData;
  }

  // Transform new structure to legacy structure
  const transformedData = {
    RolesList: [],
    IsDefaultOwnersSelected: responseData.IsDefaultOwnersSelected || false,
    PM: responseData.PM || "",
  };

  responseData.ArtworkAgilityProjects.forEach((project) => {
    const ownerList = (project.OwnerList || []).map(owner => ({
      Person: owner.Person,
      pyName: owner.pyName || owner.Person, // Fallback to Person if pyName not available
      Rank: owner.Rank
    }));

    // Sort owners by Rank (ascending) for priority-based ordering
    ownerList.sort((a, b) => (a.Rank || 999) - (b.Rank || 999));

    transformedData.RolesList.push({
      Role: project.Role,
      DefaultOwner: project.DefaultOwner || "",
      OwnerList: ownerList,
    });
  });

  return transformedData;
};

export const getRoleOwnerDetailsapi = async (projectId, BU, Region) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL;
  try {
    apiURL = `${DEVURL}/getRoleOwnerDetails/${BU}/${Region}/${projectId}`;
    const roleOwnerList = await axiosInstance({
      url: apiURL,
      method: 'GET',
    });
    
    // Transform new API response to legacy format for backward compatibility
    if (roleOwnerList?.data) {
      roleOwnerList.data = transformRoleOwnerData(roleOwnerList.data);
    }
    
    return roleOwnerList;
  } catch (error) {
    console.log(error.message);
  }
};

export const updateRoleAndOwnerApi = async (payload) => {
    const api = new Api();
    const axiosInstance = await api.init({ headers });
    let apiURL
    try {
        apiURL = `${DEVURL}/storeTaskOwnerDetails`;
        const storeRoleOwner = await axiosInstance({
            url: apiURL,
            method: "POST",
            data: payload,
        });
        return storeRoleOwner;
    }
    catch (error) {
        console.log(error.message)
    }
};
